import React from 'react';
import { Helmet } from 'react-helmet-async';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import RedirectLoggedIn from './../../Components/Redirectors/RedirectLoggedIn';
import PageviewTracker from '../../Components/PageviewTracker/PageviewTracker';

import View from './View';

import messages from './messages';

const timeToGreetingKey = () => {
  const now = new Date();
  const greetingsDictionary = [
    {
      hours: [2, 3, 4, 5, 6, 7, 8],
      messageKey: 'morningHeadline',
    },
    {
      hours: [9, 10, 11, 12, 13, 14, 15, 16, 17],
      messageKey: 'dayHeadline',
    },
    {
      hours: [18, 19, 20, 21, 22, 23, 0, 1],
      messageKey: 'nightHeadline',
    },
  ];

  const { messageKey } = greetingsDictionary.find(({ hours }) =>
    hours.includes(now.getHours())
  );

  return messageKey;
};

const Logout = ({ intl, greetingKey }) => (
  <>
    <RedirectLoggedIn />
    <Helmet title={intl.formatMessage(messages.metaTitle)} />
    <PageviewTracker
      pageName={'wbm/Welcome/logout'}
      contextData={{ EventLogout: '1' }}
    />
    <View greetingKey={greetingKey || timeToGreetingKey()} />
  </>
);

Logout.propTypes = {
  greetingKey: PropTypes.oneOf([
    'morningHeadline',
    'dayHeadline',
    'nightHeadline',
  ]),
  intl: PropTypes.shape(intlShape),
};

export default injectIntl(Logout);
